module.exports = __webpack_public_path__ + "assets/2bfb22950ddac07bebb9586e5c15b7b7.svg";